import { useId, useState } from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Label } from '@/components/ui/label';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { FilterRow } from './filter';

export default function FilterSelectSearch({ label, blankLabel = 'Selecione para filtrar...', options, value = '', setValue, isLoading, ...props }) {
  const id = useId();
  const [open, setOpen] = useState(false);

  return (
    <FilterRow {...props}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Popover
        open={open}
        onOpenChange={setOpen}
      >
        <PopoverTrigger asChild>
          <Button
            id={id}
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className={cn(
              'w-full justify-between rounded-md border-primary-lightest bg-background px-3 text-sm font-normal text-neutral-dark outline-none outline-offset-0',
              // Hover and focus styles
              'hover:border-neutral-light hover:bg-bright hover:text-neutral-dark focus-visible:outline-[3px]'
            )}
          >
            <span className={cn('truncate', !value && 'text-muted-foreground')}>{value ? options.find(option => option.value === value?.value)?.label || value?.label : blankLabel}</span>
            <ChevronDownIcon
              size={16}
              className="shrink-0 text-muted-foreground/80"
              aria-hidden="true"
            />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className="w-[var(--radix-popper-anchor-width)] border-solid border-input p-0"
          align="start"
        >
          <Command>
            <CommandInput
              placeholder="Buscar..."
              className="focus-visible:outline-none"
            />
            <CommandList>
              <CommandEmpty>Nenhuma opção encontrada.</CommandEmpty>
              <CommandGroup>
                <CommandItem
                  value="blank"
                  onSelect={currentValue => {
                    setValue(currentValue === value ? '' : { label: 'Todas', value: 'blank' });
                    setOpen(false);
                  }}
                >
                  Todas
                  {value?.value === 'blank' && (
                    <CheckIcon
                      size={16}
                      className="ml-auto"
                    />
                  )}
                </CommandItem>
                {isLoading
                  ? 'Carregando...'
                  : options.map(option => (
                      <CommandItem
                        key={option.value}
                        value={option.value}
                        onSelect={currentValue => {
                          setValue(currentValue === value ? '' : { label: option.label, value: option.value });
                          setOpen(false);
                        }}
                      >
                        {option.label}
                        {value?.value === option.value && (
                          <CheckIcon
                            size={16}
                            className="ml-auto"
                          />
                        )}
                      </CommandItem>
                    ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </FilterRow>
  );
}
